import { Link } from "react-router-dom";
import { UtensilsCrossed, MapPin, MessageCircle, ShoppingBag } from "lucide-react";
import { BUSINESS } from "../data/business";

export default function BottomBar() {
  return (
    <nav
      className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-cream/95 backdrop-blur-xl border-t border-line"
      aria-label="Aksi cepat"
      data-testid="mobile-quick-bar"
    >
      <div className="grid grid-cols-4">
        <Link to="/menu/" data-testid="quick-menu-link" className="flex flex-col items-center gap-1 py-2.5 text-ink">
          <UtensilsCrossed size={20} />
          <span className="text-[11px] font-semibold">Menu</span>
        </Link>
        <Link to="/lokasi/" data-testid="quick-lokasi-link" className="flex flex-col items-center gap-1 py-2.5 text-ink">
          <MapPin size={20} />
          <span className="text-[11px] font-semibold">Lokasi</span>
        </Link>
        <a href={BUSINESS.links.whatsapp} target="_blank" rel="noopener noreferrer" data-testid="quick-whatsapp-link" className="flex flex-col items-center gap-1 py-2.5 text-leaf">
          <MessageCircle size={20} />
          <span className="text-[11px] font-semibold">WhatsApp</span>
        </a>
        <a href={BUSINESS.links.orderOnline} target="_blank" rel="noopener noreferrer" data-testid="quick-order-link" className="flex flex-col items-center gap-1 py-2.5 text-terracotta">
          <ShoppingBag size={20} />
          <span className="text-[11px] font-semibold">Pesan</span>
        </a>
      </div>
    </nav>
  );
}
